import { activityHistoryFiltersSlice } from "../../slice";

export const { setDiagnosticFilterValues } = activityHistoryFiltersSlice.actions;
